export const VISA_REQUIRED_UPDATE_FIELDS = {
  visaNumber: 'visaNumber',
  visaValidity: 'visaValidity',
};
